//Library imports
import styled from "styled-components";
import { Avatar } from "antd";

interface IMostEngaged {
  id?: string;
  title: string;
  data: {
    profile_image?: string;
    company_logo?: string;
    contact_name?: string;
    company_name?: string;
    color?: string;
    contact_email?: string;
  }[];
  Square?: boolean;
  message?: string;
}

const MostEngaged = (props: IMostEngaged) => {
  const { id, title, data, Square, message } = props;
  const displayArrayLength = 8;
  const displayDataArray = data?.slice(0, displayArrayLength);
  return (
    <Wrapper {...(id ? { id: id } : {})}>
      <div className="heading-style">{title}</div>

      <div className="d-flex-outer">
        {displayDataArray?.length > 0
          ? displayDataArray?.map((obj, index) => {
              const image = obj.profile_image || obj.company_logo;
              const name = obj.contact_name || obj.company_name;
              const email = obj.contact_email;
              const color = obj.color;
              return (
                <div key={index} className="d-flex">
                  {Square === true ? (
                    <Avatar
                      shape="square"
                      size={48}
                      style={{
                        backgroundColor: `${color ? color : "#C8C8C8"}`,
                        borderRadius: 9,
                      }}
                      src={image}
                    />
                  ) : (
                    <Avatar size={48} style={{ backgroundColor: "#C8C8C8" }} src={image} />
                  )}
                  <div className="text-styling">
                    {(name !== undefined && name.trim()) || email}
                    {/* {name && name?.substring(0, 6)} */}
                    {/* {name && name?.length > 6 ? "..." : null} */}
                  </div>
                </div>
              );
            })
          : message}
        <div className="d-flex">
          {/* {dataArrayLength > displayArrayLength ? (
            Square === true ? (
              <Avatar
                className="text-styling3"
                shape="square"
                size={48}
                style={{
                  backgroundColor: "#C8C8C8",
                  borderRadius: 9,
                  color: "#FFFFFF",
                  fontSize: 18,
                }}
              >
                {dataArrayLength - displayArrayLength}
              </Avatar>
            ) : (
              <Avatar
                className="text-styling3"
                size={48}
                style={{
                  backgroundColor: "#C8C8C8",
                  color: "#FFFFFF",
                  fontSize: 18,
                }}
              >
                {dataArrayLength - displayArrayLength}
              </Avatar>
            )
          ) : null} */}

          {/* {dataArrayLength > displayArrayLength ? (
            <div
              onClick={() => {
                if (history.location.pathname.startsWith("/campaigns/content/asset"))
                  history.push(
                    `/campaigns/content/asset/audience?campaign_id=${getQueryCampaignId()}&asset_id=${getQueryAssetId()}`
                  );
                else history.push(`/campaigns/content/audience?campaign_id=${getQueryCampaignId()}`);
              }}
              className="text-styling2 clickable"
            >
              More...
            </div>
          ) : null} */}
        </div>
      </div>
    </Wrapper>
  );
};

export default MostEngaged;

const Wrapper = styled.div`
  margin: 0 2.25em;
  .ant-avatar {
    min-width: 48px;
    max-width: 48px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 38px;
      max-width: 38px;
      height: 38px !important;
    }
  }
  .ant-avatar-string {
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      line-height: 38px !important;
    }
  }
  .heading-style {
    color: #424b50;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 1em;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .clickable {
    cursor: pointer;
  }
  .d-flex-outer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    font-family: "Roboto Slab", serif;
  }
  .d-flex {
    margin-bottom: 1em;
    display: flex;
    align-items: center;
    justify-content: flex-star;
    width: 50%;
  }
  .text-styling {
    color: #7e7e7e;
    font-weight: 700;
    font-size: 14px;
    font-family: "robotoregular";
    margin: 0 0 0 5px;
    width: 75px;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .text-styling2 {
    color: #27ce0a;
    font-weight: 600;
    font-size: 14px;
    font-family: "robotoregular";
    margin: 0 1em 0 0.25em;
    width: 75px;
    overflow-wrap: break-word;
  }
  .text-styling3 {
    color: #ffffff;
    font-size: 18px;
    width: 75px;
    overflow-wrap: break-word;
  }
`;
